module.exports = __webpack_public_path__ + "static/media/manifest_active.578cf35b.svg";